module.exports = __webpack_public_path__ + "media/styles/images/png/play-overlay-teal-20132f0d113f374f0c273bade0f84af8.png";